import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const sponsorHighlightGQLQuery = () => {
  const imageSize = getIsLowBandwidth() ? 200 : 400
  return gql(`{
    OneOffPage(id: "/expohall") {
      content {
        ... on ListModule {
          items {
            url
            image {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                  }
                }
            }
          }
        }
      }
    }
}
  `)
}

export const dummy = () => {}
